import React from 'react';

const AgentCardShimmer = () => {
  // Shimmer animation class
  const shimmerClass = "animate-[shimmer_2s_infinite] bg-gradient-to-r from-gray-800/50 via-gray-700/50 to-gray-800/50 bg-[length:400%_100%]";
  
  const ShimmerCard = () => (
    <div className="bg-[#1A1721]/50 rounded-xl p-6 border border-gray-800">
      <div className="grid grid-cols-1 md:grid-cols-7 gap-4 md:gap-6 md:items-center">
        {/* Name and Description - Col span 2 */}
        <div className="col-span-1 md:col-span-2">
          <div className="flex flex-col gap-3">
            <div className={`h-6 w-32 rounded-md ${shimmerClass}`} />
            <div className="flex gap-2">
              <div className={`h-4 w-4 rounded-full ${shimmerClass}`} />
              <div className={`h-4 w-4 rounded-full ${shimmerClass}`} />
              <div className={`h-4 w-4 rounded-full ${shimmerClass}`} />
            </div>
            <div className={`h-4 w-full rounded-md ${shimmerClass}`} />
          </div>
        </div>

        {/* Level of Autonomy */}
        <div className="flex justify-between items-center md:block">
          <span className="text-gray-400 md:hidden">Level:</span>
          <div className={`h-7 w-20 rounded-md ${shimmerClass}`} />
        </div>

        {/* Market Cap */}
        <div className="flex justify-between items-center md:block">
          <span className="text-gray-400 md:hidden">Market Cap:</span>
          <div className={`h-6 w-24 rounded-md ${shimmerClass}`} />
        </div>

        {/* Token Utility */}
        <div className="flex justify-between items-center md:block">
          <span className="text-gray-400 md:hidden">Token Utility:</span>
          <div className="flex items-center gap-1 h-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className={`w-2 h-full rounded-sm ${shimmerClass}`} />
            ))}
          </div>
        </div>

        {/* Open Source Status */}
        <div className="flex justify-between items-center md:block">
          <span className="text-gray-400 md:hidden">Open Source:</span>
          <div className={`h-6 w-24 rounded-md ${shimmerClass}`} />
        </div>

        {/* Framework */}
        <div className="flex justify-between items-center md:block">
          <span className="text-gray-400 md:hidden">Framework:</span>
          <div className={`h-6 w-24 rounded-md ${shimmerClass}`} />
        </div>
      </div>

      {/* Tags */}
      <div className="flex flex-wrap gap-2 mt-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className={`h-6 w-16 rounded-md ${shimmerClass}`} />
        ))}
      </div>
    </div>
  );

  return (
    <div className="space-y-4">
      {[1, 2, 3].map((i) => (
        <ShimmerCard key={i} />
      ))}
    </div>
  );
};

export default AgentCardShimmer;